import { capitalDesignTokens, createTypedSxStyles } from '@opengov/capital-mui-theme';


export const styles = createTypedSxStyles({
  header: {
    background: capitalDesignTokens.semanticColors.background.primary,
    padding: '16px',
  },
  headerContent: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  buttons: {
    display: 'flex',
    gap: '8px',
  },
});
